var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 33,
    viewBox: "0 0 52 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_5805_15695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.8399 21.8633H9.36719V24.162H42.8399V21.8633Z",
    fill: "#1C5080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.8399 4.20898H9.36719V21.8645H42.8399V4.20898Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.9752 5.46094H11.1406V20.0572H25.9752V5.46094Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30.2237 29.0636H21.0383C20.6761 29.0636 20.3828 28.7698 20.3828 28.4068C20.3828 28.0438 20.6761 27.75 21.0383 27.75H30.2237C30.5859 27.75 30.8792 28.0438 30.8792 28.4068C30.8792 28.7698 30.5859 29.0636 30.2237 29.0636Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M46.4668 0H4.78332C3.6276 0 2.6875 0.941975 2.6875 2.1V28.1469H48.5626V2.1C48.5626 0.941975 47.6225 0 46.4668 0ZM46.2943 26.6H4.94719V1.80617H46.2943V26.6Z",
    fill: "#1C5080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M48.8248 30.6792H2.43218C1.09535 30.6792 0 29.5817 0 28.2422V28.9681C0 30.3076 1.09535 31.4052 2.43218 31.4052H19.1987C19.1987 31.4138 19.1987 31.4138 19.1987 31.4224V31.7163C19.1987 32.0792 19.492 32.3731 19.8542 32.3731H31.4028C31.765 32.3731 32.0583 32.0792 32.0583 31.7163V31.4224C32.0583 31.4138 32.0583 31.4138 32.0583 31.4052H48.8248C50.1617 31.4052 51.257 30.3076 51.257 28.9681V28.2422C51.257 29.5817 50.1617 30.6792 48.8248 30.6792Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.0764 5.46094H28.7344V20.0572H41.0764V5.46094Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M39.9889 9.73047H29.8203V10.128H39.9889V9.73047Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M39.9889 8.2168H29.8203V8.61433H39.9889V8.2168Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.9889 6.70508H29.8203V7.10261H39.9889V6.70508Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M39.9889 16.3418H29.8203V16.5406H39.9889V16.3418Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M39.9889 17.0938H29.8203V17.2925H39.9889V17.0938Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M39.9889 17.8535H29.8203V18.0523H39.9889V17.8535Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M39.9889 18.6055H29.8203V18.8042H39.9889V18.6055Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M39.9927 14.8203H34.8438V15.0969H39.9927V14.8203Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M39.9927 13.3086H34.8438V13.5851H39.9927V13.3086Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M39.9927 11.7949H34.8438V12.0715H39.9927V11.7949Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M34.2793 11.5352H29.8203V15.2166H34.2793V11.5352Z",
    fill: "#1F8ACB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M21.6634 11.1487C21.6289 11.4339 21.5944 11.8314 21.5599 12.3154C21.4392 12.4364 21.3529 12.6092 21.2667 12.6006C21.1114 12.5833 20.9907 11.9697 20.9993 9.93884C20.2144 9.75736 19.5935 9.78329 19.1622 9.84378C18.4636 9.93884 17.9202 10.1808 17.3251 9.91292C17.075 9.80057 16.9025 9.63637 16.799 9.51539C16.7732 9.70551 16.7128 9.9302 16.5403 10.0425C16.3678 10.1549 16.2384 10.0598 16.0832 10.1376C15.9797 10.1981 15.8244 10.3623 15.8848 11.4166C15.9021 11.7104 15.9366 12.1166 16.0142 12.6006C15.9193 12.5228 15.7899 12.4277 15.6174 12.3413C15.5139 12.2808 15.4277 12.2376 15.3587 12.203C15.3242 11.5981 15.3328 11.0882 15.3587 10.6993C15.4536 9.066 15.7727 8.89316 15.8848 8.8586C16.0487 8.7981 16.2212 8.8586 16.3419 8.92773C16.247 8.55613 16.385 8.18452 16.6697 8.00304C16.8422 7.89069 17.006 7.95983 17.3251 7.9339C17.7823 7.89934 17.9547 7.74378 18.3774 7.60551C18.6447 7.51909 19.421 7.26847 20.0851 7.53637C20.7492 7.81292 21.0424 8.51292 21.1373 8.78946C21.3012 8.9623 21.534 9.24748 21.6634 9.64501C21.81 10.0944 21.741 10.4487 21.6634 11.1487Z",
    fill: "#0C1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M17.4397 16.1776C17.0516 16.1344 16.3271 16.1085 15.6026 16.506C14.4641 17.1282 13.8259 18.5282 13.9639 20.0579C17.2154 20.0579 20.467 20.0579 23.7185 20.0579C23.753 19.6603 23.7789 18.7875 23.2873 17.8887C23.0199 17.4048 22.7094 17.111 22.6318 17.0332C21.6917 16.169 20.4584 16.1603 20.0702 16.1776C19.1819 16.1776 18.3108 16.1776 17.4397 16.1776Z",
    fill: "#0C1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M21.9937 13.2487C21.7608 13.4647 21.4417 13.3869 21.4158 13.3783C21.3554 13.6462 21.2088 14.1388 20.8121 14.6314C20.3636 15.1931 19.8289 15.4437 19.5615 15.5561C19.5529 15.9968 19.5442 16.4289 19.5356 16.8697C19.5184 16.9129 19.2424 17.4573 18.6386 17.5264C18.1643 17.5869 17.6899 17.319 17.457 16.8697C17.4829 16.4721 17.5002 16.0832 17.526 15.6857C17.2587 15.5647 16.7153 15.2622 16.2754 14.6314C15.9305 14.1388 15.8097 13.6635 15.7666 13.3783C15.413 13.5338 15.0162 13.4388 14.8351 13.1795C14.5591 12.7993 14.8265 12.1943 15.0939 12.1252C15.1629 12.1079 15.2491 12.1252 15.3612 12.1857C15.4302 12.2203 15.5165 12.2635 15.62 12.324C15.7838 12.419 15.9218 12.5141 16.0167 12.5832C15.9391 12.0993 15.9046 11.6931 15.8873 11.3993C15.8356 10.3363 15.9908 10.1721 16.0857 10.1203C16.2323 10.0338 16.3617 10.1376 16.5428 10.0252C16.7153 9.91286 16.7843 9.68817 16.8016 9.49805C16.9051 9.61903 17.0775 9.78323 17.3277 9.89558C17.9228 10.1635 18.4661 9.9215 19.1647 9.82644C19.5874 9.76595 20.2083 9.74002 21.0018 9.9215C20.9932 11.9524 21.1139 12.5659 21.2692 12.5832C21.3554 12.5919 21.4417 12.419 21.5624 12.298C21.6314 12.2289 21.7004 12.1771 21.7953 12.1857C21.9937 12.203 22.1144 12.4795 22.123 12.5141C22.2093 12.7301 22.2179 13.0499 21.9937 13.2487Z",
    fill: "#F6D8CE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M13.4304 23.0308V22.4863H12.5766V23.0308H10.1875V23.4283H12.5766V23.8085H13.4304V23.4283H42.0819V23.0308H13.4304Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5805_15695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.257,
    height: 32.3728,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame1.93638ecbf9ca6f79e0647acb38d73802.svg";
export { ForwardRef as ReactComponent };